import {each} from 'underscore';
import xhr from './Xhr';
import {handleDataLayerProductClick, dataLayerProductImpressions} from './dataLayers';

export default class RatingFormSubscriber {
    constructor() {
        this.CLASSES = {
            form_wrapper: 'js-rating-form-wrapper',
            trigger: {
                submit: 'js-rating-subscriber'
            }
        };

        this.INPUTNAMES = {
            rating: 'programme_track_rating[rating]',
            comment: 'programme_track_rating[comment]',
            token: 'programme_track_rating[_token]'
        };

        this.addRatingEventListener();
    }

    addRatingEventListener() {
        each(document.querySelectorAll(`.${this.CLASSES.trigger.submit}`),
            (el) => {
                el.addEventListener('submit',
                    (event) => this.submitForm(event));
            });
    }

    submitForm(event) {
        event.preventDefault();

        const button = event.target;
        const form = button.closest('form');

        const url = form.getAttribute('action');

        if (url) {
            // Build data params
            let data = '';
            each(this.INPUTNAMES, (inputField) => {
                const el = form.querySelector(`[name="${inputField}"]`);
                if (el === null) {
                    return;
                }

                let value;

                switch (el.type) {
                    case 'checkbox':
                        if (el.checked) {
                            value = el.checked;
                        }
                        break;
                    case 'radio':
                        if (form.querySelector(`[name="${inputField}"]:checked`) !== null) {
                            value = form.querySelector(`[name="${inputField}"]:checked`).value;
                        }
                        break;
                    default:
                        value = el.value;
                        break;
                }

                if (value) {
                    data += `${inputField}=${value}&`;
                }
            });

            xhr.post(url, data).then((request) => {
                const response = request.responseText;
                const wrapper = document.querySelectorAll(`.${this.CLASSES.form_wrapper}`)[0];

                if (typeof wrapper !== 'undefined') {
                    wrapper.innerHTML = response;
                }

                this.reloadEventListeners();

                handleDataLayerProductClick();
                dataLayerProductImpressions();
            });
        }
    }

    reloadEventListeners() {
        this.addRatingEventListener();
    }
}



// WEBPACK FOOTER //
// ./src/Will/WebsiteBundle/Resources/ui/js/RatingFormSubscriber.js